// @owners { team: patients }

type Images = typeof import('./fuzerx').images;

// Web-only (getImage.native.ts is preferred on native): the catalog is code-split out of the
// eager bundle and loaded once at startup by the ThemeProvider.
export async function loadImages(): Promise<Images> {
  // webpack: /* webpackChunkName: "images-fuzerx" */
  return (await import('./fuzerx')).images;
}

// Populated by setImages() once loadImages() resolves; empty until then.
let IMAGES = {} as Images;
export const setImages = (images: Images) => {
  IMAGES = images;
};

export const getImage = (imageName: keyof Images) => {
  return IMAGES[imageName];
};
